import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { FileDescriptorModule } from '../file-descriptor/file-descriptor.module';
import { SharedModule } from '../../shared/shared.module';
import { DialogModalComponent } from '../../shared/components/dialog-modal/dialog-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DocumentsGridRouterModule } from "./documents-grid.routing";
import { DocumentsGridComponent } from './pages/documents-grid/documents-grid.component';
import { UploadDocumentComponent } from './components/upload-document/upload-document.component';
import { DocumentProcessDetailsComponent } from './pages/document-process-details/document-process-details.component';
import { NgxLoadingModule } from 'ngx-loading';
import { DocumentFilterPipe } from "src/app/pipe/document-filter.pipe";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        DocumentsGridRouterModule,
        ReactiveFormsModule,
        FileDescriptorModule,
        SharedModule,
        NgSelectModule,
        NgxLoadingModule,
    ],
    exports: [],
    declarations: [DocumentsGridComponent, UploadDocumentComponent, DocumentProcessDetailsComponent,DocumentFilterPipe,
    ],
    providers: [],
    entryComponents: [DialogModalComponent, UploadDocumentComponent]
})
export class DocumentsGridModule { }